import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "../components/Layout";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErr("");
        try {
            const { data } = await api.post("/admin/login", { email, password });
            localStorage.setItem("ash_admin_token", data.token);
            navigate("/admin");
        } catch (e) {
            setErr(e.response?.data?.detail || "Could not log in");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout minimal>
            <section className="max-w-md mx-auto px-6 py-16" data-testid="admin-login-section">
                <div className="text-xs uppercase tracking-widest font-bold text-ash-orange mb-3">ASH Admin</div>
                <h1 className="font-display font-black text-4xl tracking-tighter text-ash-black">Sign in</h1>
                <p className="mt-3 text-ash-gray-dark">Review submissions and download reports.</p>

                <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="admin-login-form">
                    <div>
                        <label className="block text-xs uppercase tracking-widest font-bold text-ash-gray-dark mb-2">Email</label>
                        <input
                            type="email"
                            className="field-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="admin-login-email"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-xs uppercase tracking-widest font-bold text-ash-gray-dark mb-2">Password</label>
                        <input
                            type="password"
                            className="field-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="admin-login-password"
                            required
                        />
                    </div>
                    {err && <div className="text-sm text-red-600" data-testid="admin-login-error">{err}</div>}
                    <button type="submit" className="btn-primary w-full justify-center" disabled={loading} data-testid="admin-login-submit">
                        {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign in"}
                    </button>
                </form>
            </section>
        </Layout>
    );
}
